
async function renderReviews(productCard) {
  const productId = productCard.dataset.id;
  const fetchProductReviews = () => {
      $.ajax({
          url: `https://api.yotpo.com/v1/widget/NuCBdWmL7wbp5ZMCg5wkVqf8LCFcKtpudpSpnV35/products/${productId}/reviews.json`,
          dataType: "json",
          success: function (data) {
              const averageRating = data.response.bottomline.average_score;
              const totalReviews = data.response.bottomline.total_review;
              renderCollectionReviewsSummary(averageRating, totalReviews);
          },
          error: function (XMLHttpRequest) {
              var response = eval("(" + XMLHttpRequest.responseText + ")");
              response = response.description;
              console.log(`Yotpo error: ${response}`);
          },
      });
  };
  const renderCollectionReviewsSummary = (averageRating, totalReviews) => {
      var container = $(`.product-v2--review-count-plp-${productId}`);
      var stars = "";
      let fullStars = Math.floor(averageRating);
      let middleStars = (Math.ceil(averageRating) - Math.floor(averageRating)) > 0 ? 1 : 0;
      let emptyStars = 5 - Math.ceil(averageRating);
      for (let s = 0; s < fullStars; s++) {
          stars += `<img alt="Full review stars new" src="${yotpoStars.full}" width="17" height="15" />`;
      }
      for (let s = 0; s < middleStars; s++) {
          stars += `<img alt="Medium review stars" src="${yotpoStars.middle}" width="17" height="15"/>`;
      }
      for (let s = 0; s < emptyStars; s++) {
          stars += `<img alt="Empty review stars" src="${yotpoStars.empty}" width="17" height="15"/>`;
      }
     
      if (totalReviews > 0) {
          var html = `
              <div class="yotpo-widget-instance" data-yotpo-instance-id="806196" data-yotpo-product-id="${productId}" data-yotpo-cart-product-id="${productId}" data-yotpo-section-id="collection"></div>
          `;
          container.prepend(html);
      } else {
          var html = `<!-- no reviews -->`;
          container.prepend(html);
      }
  };
  fetchProductReviews();
}

async function renderPrice(productCard, swatchClicked) {
  const productId = productCard.dataset.id;
  const productVariantsData = ProductData[productId].variants;
  console.log('productVariantsData', productVariantsData)
  const variantColor = swatchClicked.getAttribute('id').split('--').slice(-1)[0].toLowerCase().replace(/[-/]/g, ' ').trim();
  const selectedVariant = productVariantsData.find(variant =>
    variant.option1.toLowerCase().replace(/[-/]/g, ' ').trim() === variantColor
  );
  console.log('selectedVariant', selectedVariant);
  if (selectedVariant) {
    const priceSelectors = productCard.querySelectorAll('.price-item--sale');
    console.log('priceSelectors', priceSelectors);
    if (priceSelectors.length > 0) {
      priceSelectors.forEach(priceSelector => {
        priceSelector.innerHTML = `<span class="money">${theme.Currency.formatMoney(selectedVariant.price)}</span>`;
      });
    } else {
    
    }
  } else {

  }  
}







async function renderchangeImages(productCard, swatchClicked) {
  const productId = productCard.dataset.id;
  const productVariantsData = ProductData[productId].variants;
  const productVariantJson = JSON.stringify(productVariantsData);
  const productVariants = JSON.parse(productVariantJson);
  const productImages = ProductData[productId].images; 
  const swatches = document.querySelectorAll(`a.swatch--${productId}`); 

  swatches.forEach(swatch => swatch.classList.remove('swatch-active')); 
  swatchClicked.classList.add('swatch-active'); 

  const id = swatchClicked.getAttribute('id');
  const variantColor = id.split('--').slice(-1)[0].toLowerCase().replace(/[-/]/g, ' ').trim();

  console.log(`Swatch clicked for color: ${variantColor}`);

  if (screen.width < 768) {
      $(`.media-img-container-slick-${productId}`).slick('slickGoTo', 0);
  }

  const thisVariant = productVariants.filter(variant =>
      variant.option1.toLowerCase().replace(/[-/]/g, ' ').trim() === variantColor
  );

  console.log('thisVariant', thisVariant);

  if (!thisVariant.length) {
      console.warn(`No variant found for color: ${variantColor} on product: ${productId}`);
      return;
  }

  if (!thisVariant[0].featured_image) {
      console.warn(`No featured_image found for variant: ${thisVariant[0].id}`);
      return;
  }

  const mainImageSelector = document.querySelector(`.filter-product-item-main-image-change-${productId}`);
  if (mainImageSelector) {
      mainImageSelector.setAttribute('srcset', thisVariant[0]['featured_image']['src'] + "&width=600&sw=d");
  }

  const mobileImageSelector = document.querySelector(`.filter-product-item-main-image-change-${productId}-mobile`);
  if (mobileImageSelector) {
      mobileImageSelector.setAttribute('srcset', thisVariant[0]['featured_image']['src'] + "&width=180&sw=d");
  }

  const secondImageSrc = SearchVariantImagesArray(productImages, thisVariant[0].featured_media.id);
  if (secondImageSrc && secondImageSrc !== -1) {
      const secondImageSelector = document.querySelector(`.filter-product-item-main-image-change2-${productId}`);
      if (secondImageSelector) {
          secondImageSelector.setAttribute('srcset', secondImageSrc.src + "&width=600&sw=d2");
      }
  } else {
      console.warn(`No second image found for variant: ${thisVariant[0].id}`);
  }

  let optionSizes = [];
  thisVariant.forEach(variant => {
      if (optionSizes.filter(opt => opt.size === variant.option2).length === 0) {
          optionSizes.push({ size: variant.option2, id: variant.id, available: variant.available, color: variant.option1 });
      }
  });

  document.getElementById(`variant-sizes-${productId}`).innerHTML = '';
  document.getElementById(`variant-sizes-${productId}-mobile`).innerHTML = '';

  optionSizes.forEach(v => {
      if (v.available) {
          document.getElementById(`variant-sizes-${productId}`).innerHTML += `
              <div class="size-OptionSTL">
                  <a href="" class="addToCartBySwatch" variant-id="${v.id}" onclick="event.preventDefault(); addToCartBySwatch(${v.id}, ${v.price}, 'top')">${v.size}</a>
              </div>`;
          document.getElementById(`variant-sizes-${productId}-mobile`).innerHTML += `
              <div>
                  <a>${v.size}</a>
                  <a href="" class="addToCartBySwatch addToCartBySwatch--text" variant-id="${v.id}" onclick="event.preventDefault();   addToCartBySwatchOverlay(); hideMobileQuickAdd(); addToCartBySwatch(${v.id}, ${v.price}, 'top')">ADD TO BAG +</a>
                  <span class="variant-color--active">${v.color}</span>
              </div>`;
      } else {
          document.getElementById(`variant-sizes-${productId}`).innerHTML += `
              <div class="disabled-size"><a>${v.size}</a></div>`;
          document.getElementById(`variant-sizes-${productId}-mobile`).innerHTML += `
              <div class="disabled-size addToCartBySwatch--text">
                  <a>${v.size}</a><p>OUT OF STOCK</p>
                  <span class="variant-color--active">${v.color}</span>
              </div>`;
      }
  });
}

async function processProductCards(new_products) {
  let productCards = new_products.find('li').get();
  for (const productCard of productCards) {
      await renderbuildSwatches(productCard);
      await renderchangeImages(productCard); 
      await renderbuildImages(productCard);
      await QuickAdd(productCard);
      await renderReviews(productCard);
  }
}

function addToCartBySwatch(variantId, price, type) {

  setTimeout(() => {
    hidoGlobalOverlay = document.getElementById('overlay');
    if(hidoGlobalOverlay) {
      hidoGlobalOverlay.style.display = "none";
    }
  }, "1000");

  sessionStorage.setItem("VariantID", variantId);

  window.QuickAddProduct(variantId);

  let itemTitle
  window.gtmDataLayer.push({ecommerce: null});
  window.gtmDataLayer.push({
    'event': 'add_to_cart',
    'ecommerce': {
      'add': {
        'products': [
          {
            'id': variantId,
            'category': type,
            'brand': 'Alpha Industries',
            'variant': variantId,
            'price': price,
            'quantity': 1
          }
        ]
      },
      'items': [
        {
          'id': variantId,

// 'item_id': '{{ product.id }}',
          'category': type,
          'item_category': type,
          'brand': 'Alpha Industries',
          'item_brand': 'Alpha Industries',
          'variant': variantId,
          'item_variant': variantId,
          'price': price,
          'quantity': 1
        }
      ]
    }
  });


  const pageTitle = '{{ page_title }}'.replace(/&#39;/g, '\'');
  window.gtmDataLayer.push({
    'page_title': pageTitle, 'event': 'view_cart', // ga4
    'event_name': 'view_cart'
  });
}

function SearchVariantImagesArray(array, valuetofind) {
    for (let i = 0; i < array.length; i++) {
        if (array[i]['id'] === valuetofind) {
            return array[i + 1]; 
        }
    }
    return -1; 
}

function setupSwatchClickHandlers() {
  const swatches = document.querySelectorAll('.swatch-color');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function (event) {
      event.preventDefault();
      const productCard = swatch.closest('.grid__item_collections');
      if (productCard) {
        renderchangeImages(productCard, swatch);
        renderPrice(productCard, swatch);
      }
    });
  });
}


async function loadMoreProducts() {
  var products_on_page = $('.container_grid_collections');
  var next_url = products_on_page.data('next-url');

  if (next_url === "") {
      $('#loadMore').hide();
  }

  $('body').on('click', '#loadMore', function (e) {
      e.preventDefault();
      var thisButton = $(this);

      if (thisButton.attr('href') !== "") {
          $.ajax({
              url: thisButton.attr('href'),
              type: 'GET',
              datatype: 'html',
              beforeSend: function () {
                  thisButton.hide();
                  $('.plp-loader').fadeIn('fast');
              }
          }).done(function (next_page) {
              var new_products = $(next_page).find('.container_grid_collections');
              var products_on_page = $('.container_grid_collections');
              next_url = new_products.data('next-url');

             
              products_on_page.append(new_products.html());

          
              setupSwatchClickHandlers();

              if (next_url) {
                  thisButton.fadeIn('fast');
                  $('.plp-loader').hide();
              } else {
                  $('.plp-loader').hide();
              }

              thisButton.attr('href', next_url);

              $(document).ready(async function () {
                let productCards = new_products.find('li').get();
                for (const productCard of productCards) {
                    await renderReviews(productCard);
                  }
              });
              
          });
      }
  });
}

function addToCartBySwatchOverlay() {
  setTimeout(() => {
    hidoGlobalOverlay = document.getElementById('overlay');
    if(hidoGlobalOverlay) {
      hidoGlobalOverlay.style.display = "none";
    }
  }, "1000");
}

$(document).ready(async function () {
  setupSwatchClickHandlers();
  loadMoreProducts(); 

  let productCards = document.getElementsByClassName('grid__item_collections');
  for (const productCard of productCards) {
      await renderReviews(productCard);
  }
});
